import { useTranslation } from 'react-i18next'

import {
  DealPosition,
  DeliveryType,
} from '@enechain/eposition-proto/types/v1/deal_pb'

export function useSimulationOptions(): {
  dealPositions: Array<{ label: string; value: DealPosition }>
  isPhysicalFutureTradeOptions: Array<{ label: string; value: string }>
  futureDeliveryTypes: Array<{ label: string; value: DeliveryType }>
  physicalDeliveryTypes: Array<{ label: string; value: DeliveryType }>
  deliveryTypeLabels: Record<DeliveryType, string>
} {
  const { t } = useTranslation('domain')

  return {
    dealPositions: [
      { label: t('shared.position.bid'), value: DealPosition.BID },
      { label: t('shared.position.offer'), value: DealPosition.OFFER },
    ],
    isPhysicalFutureTradeOptions: [
      {
        label: t('model.simulation.physical_physical_trade'),
        value: 'false',
      },
      {
        label: t('model.simulation.physical_future_trade'),
        value: 'true',
      },
    ],
    futureDeliveryTypes: [
      {
        label: t('model.simulation.delivery_type.eex'),
        value: DeliveryType.EEX,
      },
    ],
    physicalDeliveryTypes: [
      {
        label: t('model.simulation.delivery_type.bg'),
        value: DeliveryType.BG,
      },
      {
        label: t('model.simulation.delivery_type.jepx'),
        value: DeliveryType.JEPX,
      },
    ],
    deliveryTypeLabels: {
      [DeliveryType.BG]: t('model.simulation.delivery_type.bg'),
      [DeliveryType.JEPX]: t('model.simulation.delivery_type.jepx'),
      [DeliveryType.EEX]: t('model.simulation.delivery_type.eex'),
      [DeliveryType.UNSPECIFIED]: '-',
    },
  }
}
